// LOGOS
export const NYTIMES = require('./NYTimes_Logo.jpeg')
export const WWD = require('./WWD.jpg')
export const TODAY = require('./TODAY.jpg')
export const ABC = require('./ABC.jpg')
export const FORBES = require('./FORBES.jpg')
export const REFINERY29 = require('./REFINERY29_Logo.jpeg')
export const MARIECLAIRE = require('./MARIECLAIRE_Logo.png')
export const GLAMOUR = require('./GLAMOUR_Logo.png')
export const BEAUTY_MATTER = require('./Beauty_Matter.jpg')
export const ELLE = require('./ELLE.jpg')
export const MODERN_LUXARY = require('./Modern_Luxury.jpg')
export const PR_NEWSWIRE = require('./PR_Newswire.jpg')
export const THE_TEASE = require('./The_Tease.jpg')
export const YAHOO_FINANCE = require('./Yahoo_Finance.jpg')

// ARTICLE IMAGES
export const ARTICLE20200701 = [require('./NYTimes1.jpg')]
export const ARTICLE20200201 = [
  require('./TODAY1.png'),
  require('./TODAY2.png')
]
export const ARTICLE20200202 = [require('./ABC1.png'), require('./ABC2.png')]
export const ARTICLE20191201 = [require('./FORBES1.png')]
export const ARTICLE20191001 = [require('./GLAMOUR1.png')]
export const ARTICLE20191002 = [require('./TODAY1_OCT_2019.jpg')]

export const ARTICLE20250301 = [require('./Modern Luxury_article.jpg')]
export const ARTICLE20241001 = [require('./YahooFinance2_article.jpg')]
export const ARTICLE20240801 = [require('./The Tease_article.jpg')]
export const ARTICLE20240701 = [require('./PR Newswire_article.jpg')]
export const ARTICLE20240601 = [require('./YahooFinance_article.jpg')]
export const ARTICLE20240501 = [require('./ELLE_article.jpg')]
export const ARTICLE20230101 = [require('./WWD_article.jpg')]
export const ARTICLE20230102 = [require('./Beauty Matter_article.jpg')]
